<template>
  <header class="header">
    <div class="container header__container">
      <router-link :to="{ name: 'home' }" class="header__logo">
        <Icon collection="default" name="logo" />
      </router-link>
      <nav class="header__nav">
        <a class="header__nav-link" @click="showAddModal">
          <Icon category="system" name="add-box-line" />
          <span>Добавить контент</span>
        </a>
        <router-link
          v-if="roleCheck(['admin'])"
          :to="{ name: 'department', params: { id: getDepartmentId() } }"
          class="header__nav-link"
        >
          <Icon category="system" name="settings-3-line" />
          <span>Информация на сайте</span>
        </router-link>
        <router-link v-if="roleCheck(['admin'])" :to="{ name: 'minister' }" class="header__nav-link">
          <Icon category="system" name="shield-user-fill" />
          <span>Руководитель</span>
        </router-link>
        <div v-if="roleCheck(['admin'])" class="header__nav">
          <a v-for="(item, i) in list" :key="i" class="header__nav-link" href="#">
            <Icon :category="item.icon.category" :name="item.icon.name" />
            <span>{{ item.title }}</span>
            <DropMenu :list="item.list" />
          </a>
        </div>
      </nav>
      <button class="header__mobile-btn" type="button">
        <Icon category="system" name="menu-line" />
      </button>
      <button v-if="user" class="header__user" type="button">
        <img
          v-if="user.head_img"
          :alt="`${user.name} ${user.surname}`"
          :src="user.head_img | image"
          class="header__user-img"
        />
        <span v-else :alt="`${user.name} ${user.surname}`" class="header__user-img">
          {{ (user.name || "").substr(0, 1) }}
          {{ (user.surname || "").substr(0, 1) }}
        </span>
        <span>{{ user.name }} {{ user.surname }}</span>
        <Icon category="system" name="arrow-down-s-line" />
        <UserMenuComponent />
      </button>
    </div>
  </header>
</template>

<script>
import Icon from "@/components/IconComponent.vue";
import UserMenuComponent from "./components/UserMenu.vue";
import AddModal from "../modals/components/AddModal.vue";
import DropMenu from "./components/DropMenu.vue";

/**
 * Шапка админки
 */
export default {
  name: "HeaderComponent",
  data() {
    return {
      user: window.user,
      list: [
        {
          title: "Обращения",
          icon: {
            category: "communication",
            name: "chat-smile-3-line",
          },
          list: [
            {
              title: "Обращения граждан",
              route: {
                name: "appeals",
              },
            },
            {
              title: "Разделы",
              route: {
                name: "sections",
              },
            },
          ],
        },
        {
          title: "Инструменты",
          icon: {
            category: "system",
            name: "settings-3-line",
          },
          list: [
            {
              title: "Ранжирование",
              route: "",
              list: [
                {
                  title: "Деятельность",
                  route: {
                    name: "ranging-activity",
                  },
                },
                {
                  title: "О ведомстве",
                  route: {
                    name: "ranging-about",
                  },
                },
                {
                  title: "Должностные лица",
                  route: {
                    name: "ranging-workers",
                  },
                },
                {
                  title: "Баннеры 'Под слайдером'",
                  route: {
                    name: "ranging-banners",
                  },
                },
              ],
            },
            {
              title: "Загрузка файлов",
              route: {
                name: "upload",
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    roleCheck(roles) {
      if (window.user && window.user.roles) {
        return roles.some((r) => window.user.roles.map((r) => r.name).includes(r));
      }
      return false;
    },
    getDepartmentId() {
      if (window.user && window.user.department) {
        return window.user.department.id;
      }
      return null;
    },
    getSubDepartmentId() {
      if (window.user && window.user.sub_department) {
        return window.user.sub_department.id;
      }
      return null;
    },
    showAddModal() {
      this.$store.state._modals.push({
        component: AddModal,
      });
    },
  },
  components: { DropMenu, UserMenuComponent, Icon },
};
</script>

<style lang="stylus">
@import '~@/styles/laravel-mix-fix.styl';
@import '~@/styles/mixins/svg.styl';

.header {
  width: 100%;
  background: $main_color;
  height: 60px;

  &__container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    gap: 8px;
  }

  &__logo {
    display: inline-flex;
    align-items: center;
    flex-direction: row;

    .icon {
      width: 60px;
      height: 60px;
      padding: 5px;
      margin-left: -5px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__mobile-btn {
    background: none;
    border: none;
    padding: 20px 5px;
    display: none;
    height: 100%;
    color: $white;
    margin-left: auto;
    cursor: pointer;

    +below(980px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .icon {
      width: 20px;
      height: 20px;

      svg {
        width: 100%;
        height: 100%;
        svg($white);
      }
    }
  }

  &__user {
    background: none;
    border: none;
    padding: 0 5px;
    height: 100%;
    color: $white;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;

    +above(981px) {
      margin-left: auto;
    }

    &:hover > .user-menu {
      opacity: 1;
      visibility: visible;
      transform: translateY(100%);
      pointer-events auto
    }

    &-img {
      width: 32px;
      height: 32px;
      object-fit: cover;
      object-position: center;
      border-radius: 100%;
      background: $blue;
      color $white
      font-weight bold
      text-transform: uppercase;
      line-height 30px !important
    }

    > span {
      font-weight: normal;
      font-size: 1em;
      line-height: 19px;

      +below(980px) {
        display: none;
      }
    }

    > .icon {
      width: 20px;
      height: 20px;
      transition: 0.2s;

      svg {
        width: 100%;
        height: 100%;
        svg($white);
      }
    }
  }

  &__nav {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0 25px;
    height: 100%;

    &-link {
      padding: 0 15px;
      height: 100%;
      display: flex;
      gap: 8px;
      color: $white;
      align-items: center;
      cursor: pointer;

      > .icon {
        width: 20px;
        height: 20px;

        svg {
          width: 100%;
          height: 100%;
          svg($white);
        }
      }

      &:hover > .drop-menu {
        opacity: 1;
        visibility: visible;
        transform: translateY(100%);
        pointer-events auto
      }

      &:hover, &:focus, &--active {
        font-weight: 500;
        background: $white;
        color: $black;

        > .icon svg {
          svg($dark);
        }

        &:hover {
          color: $black;
        }
      }

      > span {
        font-weight: normal;
        font-size: 1em;
        line-height: 19px;
      }
    }
  }
}
</style>
